import { render } from "./SubscriptionBoard.vue?vue&type=template&id=2c874a00"
import script from "./SubscriptionBoard.vue?vue&type=script&lang=js"
export * from "./SubscriptionBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__